import React from "react";
import InputMask from "common/components/InputMask/InputMask"

const PhoneMask = (props: any) => {
    return <InputMask {...props} mask={['(',/[1-9]/, /\d/, /\d/,')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                placeholder='(###)###-####' />
}

export default PhoneMask;